import React from 'react'
import icon from '../../../../assets/shareholdersIcon.png'
import { FaCopy } from 'react-icons/fa'
import showToast from '../../../../components/CustomToast/toastHelper'
interface FundProps{
    title?:string,
    data?:any
}
const FundWalletModal = ({title, data}:FundProps) => {
    let {accountDetails} = data ?? {}

    const copyAccountNumber =(account:string) =>{
        navigator.clipboard.writeText(account);
        showToast('Account number copied successfully', "success");
    }
  return (
    <div>
        <div className='my-6'>
            <img src={icon} className='my-3'/>
            {title && <p className='text-lg font-semibold'>{title}</p>}
            <p className='text-sm'> To fund your naira wallet, make a transfer to the account below</p>
        </div>
        <div className='my-3'>
            <div className='flex justify-between my-4'>
                <div className='flex gap-2 flex items-center'>
                    <p className='font-thin text-sm'>Bank Name:</p>
                    <p className='font-semibold text-sm'>{accountDetails?.bankName ?? "Not Available"}</p>
                </div>

            </div>
            <div className='flex justify-between my-4 hover:cursor-pointer'>
                <div className='flex gap-2 flex items-center'>
                    <p className='font-thin text-sm'>Account Number:</p>
                    <p className='font-semibold text-sm'>{accountDetails?.accountNumber ?? "Not Available"}</p>
                </div>
                <div className='flex items-center gap-1 text-sm' onClick={()=>{copyAccountNumber(accountDetails?.accountNumber)}}>
                    <FaCopy/>
                    <span>Copy</span>
                </div>
            </div>
            <div className='flex justify-between my-4'>
                <div className='flex gap-2 flex items-center'>
                    <p className='font-thin text-sm'>Account Name:</p>
                    <p className='font-semibold text-sm'>{accountDetails?.accountName ?? "Not Available"}</p>
                </div>
            </div>
        </div>
    </div>
  )
}

export default FundWalletModal
